import React from "react";
import { useTranslation } from "react-i18next";
import {
  EmptyStateWrapper,
  EmptyStateTitle,
  EmptyStateDescription
} from "./EmptyState.styled";

const EmptyState = () => {
  const { t } = useTranslation();

  return (
    <EmptyStateWrapper>
      <EmptyStateTitle>{t("impactReport.emptyState.title")}</EmptyStateTitle>
      <EmptyStateDescription>
        {t("impactReport.emptyState.description")}
      </EmptyStateDescription>
    </EmptyStateWrapper>
  );
};

export default EmptyState;
